import { render, staticRenderFns } from "./SubTeam.vue?vue&type=template&id=3a4616e8&"
import script from "./SubTeam.vue?vue&type=script&lang=js&"
export * from "./SubTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports